import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, Sparkles } from 'lucide-react';

interface WatermarkUpgradeBannerProps {
  compact?: boolean;
}

export const WatermarkUpgradeBanner: React.FC<WatermarkUpgradeBannerProps> = ({ compact = false }) => {
  if (compact) {
    return (
      <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <Lock className="w-4 h-4 text-amber-600 flex-shrink-0" />
          <p className="text-sm text-amber-900">
            <Link to="/pricing" className="font-medium underline hover:text-amber-700">Buy credits</Link> to download.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-2xl p-5 flex items-center justify-between gap-4">
      <div className="flex items-center gap-3 min-w-0">
        <div className="p-2 bg-amber-100 rounded-lg flex-shrink-0">
          <Lock className="w-4 h-4 text-amber-700" />
        </div>
        <div>
          <p className="text-sm font-medium text-amber-900">Buy credits to download</p>
        </div>
      </div>
      <Link
        to="/pricing"
        className="flex-shrink-0 inline-flex items-center gap-1.5 px-4 py-2 bg-amber-600 text-white text-sm font-medium rounded-lg hover:bg-amber-700 transition-colors"
      >
        <Sparkles className="w-3.5 h-3.5" />
        Buy Credits
      </Link>
    </div>
  );
};
